// @ts-ignore
import React, { memo, useMemo } from 'react';
import { MyPATExpansionPanel, MyPATTextArea } from "../../../common";
import { Typography, Button, Grid, IconButton } from '@material-ui/core';
import { getNumberFromString, getNumberOrEmtpyString } from '../../../../utils';
import cx from "classnames"
import _ from "lodash"

interface CreateNotesProps {
    classes: any;
    editRights: string[],
    isError: Function,
    title: string,
    notesTitle: string,
    handleInputChange: Function,
    errorMessage: any,
    pageState: any,
    addPageComponent: Function,
    handleAddPage: Function,
    subHeadingList: any[],
    handleSubHeadingChange: Function,
    errorListForSubHeading: string[],
    addNewSubHeading: Function,
    getTitlePlaceHolder: Function,
    isArchiveNotes: Function
}

enum PAGE_RANGE {
    START = 'start',
    END = 'end'
}

const CreateObjectiveNotes = ({ classes, editRights, isError, title, subHeadingList, notesTitle, addPageComponent,
    handleInputChange, errorMessage, pageState, handleAddPage, handleSubHeadingChange,
    errorListForSubHeading, addNewSubHeading, getTitlePlaceHolder, isArchiveNotes }:
    CreateNotesProps) => {


    const updateSubHeadingNumber = (index: number, state: string, value: string) => {
        const newHeadingList = JSON.parse(JSON.stringify(subHeadingList));
        newHeadingList[index].pageRange[state] = getNumberFromString(value);
        handleSubHeadingChange(newHeadingList);

    }

    const getErrorForSubHeading = (errorState: string) => {
        return getNumberFromString(errorState) > 0 ? `${errorState} has already been associated with another Subheading, please check.` : errorState;
    }

    const handleDeleteSubHeading = (index: number) => {
        const newHeadingList = JSON.parse(JSON.stringify(subHeadingList));
        newHeadingList.splice(index, 1);
        handleSubHeadingChange(newHeadingList);
    }

    const notesStateForMemo = useMemo(() => JSON.stringify(pageState), [pageState]);

    const notesData = useMemo(() => Object.keys(pageState).
        map((_: any, index: any) =>
            addPageComponent(index)
        ), [notesStateForMemo]);

    return (
        <>
            <div className={cx(classes.greyBgPanel, "zero-margin")}>
                <MyPATExpansionPanel
                    isDisable={!editRights.includes('notes')}
                    hasExpandIcon={false}
                    variant="white"
                    sectionId="createNotes"
                    error={isError('title')}
                    customCollapseTitle={
                        <Typography variant="h6">
                            Create Practice Set
                        </Typography>
                    }
                    fullWidthControl
                >

                    <div className={classes.notesTitle}>
                        <label>Title <span className={classes.mandatory}>*</span></label>
                        <MyPATTextArea
                            name="title"
                            value={title ? title : notesTitle}
                            onChange={handleInputChange('title')}
                            placeholder={`Enter ${getTitlePlaceHolder()} Title`}
                            errorText={errorMessage.title}
                            error={isError('title')}
                            required
                            fullWidthControl
                            autoFocus
                        />
                    </div>
                    <Grid item>
                    </Grid>
                    {notesData}
                    <div className={classes.addButtonAlign}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.addPageMore}
                            onClick={() => handleAddPage()}
                        >
                            + Add Question
                        </Button>
                    </div>
                </MyPATExpansionPanel>


            </div>
            {!isArchiveNotes() && <div className={classes.marginForSubHeadingContainer}>

                <MyPATExpansionPanel
                    isDisable={!editRights.includes('notes')}
                    hasExpandIcon={false}
                    variant="white"
                    sectionId="createSubheading"
                    customCollapseTitle={
                        <Typography variant="h6" className={classes.optionalText}>
                            Subheading (Optional)
                        </Typography>
                    }
                    fullWidthControl
                >
                    {subHeadingList.map((subHeadingItem, index) =>
                        <>
                            <div className={classes.notesTitle}>
                                <Grid container justify='space-between'>
                                    <Grid item>
                                        <label>Subheading </label>
                                    </Grid>
                                    {index !== 0 && <Grid item>
                                        <IconButton
                                            className={classes.tabsNotes}
                                            style={{ marginLeft: '20px' }}
                                            onClick={() => handleDeleteSubHeading(index)}
                                        >
                                            <img alt="Cancel video upload" src="/assets/svg/learn/closePanel.svg" style={{ cursor: 'pointer', }} />

                                        </IconButton>
                                    </Grid>}
                                </Grid>
                                <MyPATTextArea
                                    name="SubHeading"
                                    value={subHeadingItem.subHeading}
                                    onChange={(event: any) => {
                                        const newHeadingList = JSON.parse(JSON.stringify(subHeadingList));
                                        newHeadingList[index].subHeading = event.target.value;
                                        handleSubHeadingChange(newHeadingList);
                                    }}
                                    placeholder="Enter Subheading here"
                                    fullWidthControl
                                />
                            </div>
                            <label>Associated Questions </label>
                            <div className={classes.associatedQuestion}>
                                <div className={cx(classes.associatedQuestionPageRange)}>
                                    <MyPATTextArea
                                        name="start"
                                        value={getNumberOrEmtpyString(subHeadingItem.pageRange.start || '')}
                                        onChange={(event: any) => {
                                            updateSubHeadingNumber(index, PAGE_RANGE.START, event.target.value);
                                        }}
                                        placeholder="Start Question No. "
                                        className={errorListForSubHeading[index] && classes.errorStateBorder}

                                    />
                                </div>
                                <Typography className={classes.associatedQuestionText}>
                                    To
                                </Typography>
                                <div className={cx(classes.associatedQuestionPageRange)}>
                                    <MyPATTextArea
                                        name="title"
                                        value={getNumberOrEmtpyString(subHeadingItem.pageRange.end || '')}
                                        onChange={(event: any) => {
                                            updateSubHeadingNumber(index, PAGE_RANGE.END, event.target.value);
                                        }}
                                        placeholder="End Question No."
                                        className={errorListForSubHeading[index] && classes.errorStateBorder}
                                    />
                                </div>
                            </div>
                            <div className={classes.subHeadingErrorMessage}>
                                {getErrorForSubHeading(errorListForSubHeading[index])}
                            </div>
                        </>
                    )}
                    <div className={classes.addButtonAlign}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.addPageMore}
                            onClick={() => addNewSubHeading()}
                        >
                            + Add Subheading
                        </Button>
                    </div>
                </MyPATExpansionPanel>
            </div>
            }

        </>
    );
}


export default memo(CreateObjectiveNotes);